var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArrowRight1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 25,
    viewBox: "0 0 34 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"arrow right 1\""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.0622 24.5939C20.7196 24.5939 20.3769 24.4676 20.1064 24.1971C19.5834 23.6741 19.5834 22.8085 20.1064 22.2855L30.0973 12.2947L20.1064 2.30385C19.5834 1.78086 19.5834 0.915227 20.1064 0.39224C20.6294 -0.130747 21.495 -0.130747 22.018 0.39224L32.9647 11.3389C33.4876 11.8619 33.4876 12.7275 32.9647 13.2505L22.018 24.1971C21.7475 24.4676 21.4048 24.5939 21.0622 24.5939Z",
    fill: "#4AC97D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.7039 13.6471H1.35258C0.613188 13.6471 3.05176e-05 13.034 3.05176e-05 12.2946C3.05176e-05 11.5552 0.613188 10.942 1.35258 10.942H31.7039C32.4433 10.942 33.0564 11.5552 33.0564 12.2946C33.0564 13.034 32.4433 13.6471 31.7039 13.6471Z",
    fill: "#4AC97D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight1);
export default __webpack_public_path__ + "static/media/icon_arrow_right_1.1e1de555366c9f8d0f238105929e7a20.svg";
export { ForwardRef as ReactComponent };